import React from 'react';
import PropTypes from 'prop-types';

import SingleSelect from '../../formElements/SingleSelect';

import form from '../../../commonStyles/formStyles.module.css';

const ModalContentReferralsCreated = ({ contracts = [], errors, selects, onChange }) => {
    return (
        <div className={form.formSection}>
            <SingleSelect
                id="contract"
                label="Contract"
                placeholder="Select contract..."
                mandatory={true}
                customClass="absoluteAndHeightControl"
                menuItems={contracts}
                selectedId={selects.contract?.id || ''}
                selected={
                    (selects.contract?.id &&
                        contracts.find((el) => el.id === selects.contract.id)) ||
                    {}
                }
                error={errors.contract}
                onChange={(id) =>
                    onChange(
                        'contract',
                        contracts.find((el) => el.id === id)
                    )
                }
            />
        </div>
    );
};

ModalContentReferralsCreated.propTypes = {
    contracts: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.object,
    selects: PropTypes.object,
    onChange: PropTypes.func
};

export default ModalContentReferralsCreated;
